<template>
  <j-grid>
    <j-grid-item
      v-for="(dashboardItem, i) in config.items"
      :key="`${config.key}-${i}`"
      :row="dashboardItem.grid[$vuetify.breakpoint.name].row"
      :col="dashboardItem.grid[$vuetify.breakpoint.name].col"
      :width="dashboardItem.grid[$vuetify.breakpoint.name].width || 1"
      :height="dashboardItem.grid[$vuetify.breakpoint.name].height || 1"
      class="pa-3"
    >
      <template v-if="dashboardItem.requiresAuth && !$auth.isAuthenticated">
        <v-card class="fill-height d-flex justify-center align-center">
          <j-loader v-if="$auth.loading" />

          <j-error-alert
            v-else-if="!$auth.isAuthenticated"
            :value="{ message: 'not authenticated' }"
            retry-text="Login"
            v-on:retry="login()"
            class="fill-height fill-width ma-0"
          />
        </v-card>
      </template>
      <dashboard-widget v-else :config="dashboardItem" />
    </j-grid-item>
  </j-grid>
</template>

<script>
import authMixin from "@/mixins/authMixin";

import JErrorAlert from "@/ui/controls/JErrorAlert";
import DashboardWidget from "@/ui/widgets/DashboardWidget";

import JGrid from "@/ui/grid/JGrid";
import JGridItem from "@/ui/grid/JGridItem";

export default {
  components: {
    JGrid,
    JGridItem,
    JErrorAlert,
    DashboardWidget,
  },
  props: {
    config: Object,
  },
  mixins: [authMixin],
};
</script>
